module.exports = __webpack_public_path__ + "static/career_progress-d59bc23106289f8a35d1fc50a13e0798.svg";